import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Section } from '../../editor-container/editor-model';
import { Subject, Subscription } from 'rxjs';
import { IframeCommunicationService } from '../../services/iframe-communication.service';
import { take, takeUntil } from 'rxjs/operators';
import { CssServicesService } from '../../services/css-services.service';
import { GridCell } from '@urbannex/storethemes';
import { CellEditorStoreService, LastActionEnum } from '../cell-editor-store.service';
import { ColorPickerPopoverComponent } from '../dialogs/color-picker-popover/color-picker-popover.component';
import { EditState } from '../../model';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { SampleImageDirectoryComponent } from '../sample-image-directory/sample-image-directory.component';
import { NbDialogService } from '@nebular/theme';

@Component({
  selector: 'kve-cell-bg-editor',
  templateUrl: './cell-bg-editor.component.html',
  styleUrls: ['./cell-bg-editor.component.scss']
})
export class CellBgEditorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() section: Section;
  @Input() cellId: string;
  @Input() selectedCell: GridCell
  @Input() isPopup: boolean;
  width: string;

  themeVariables$: Subscription;
  pageBgColor$: Subscription;
  pageBgColor: string;
  bgColors$: Subscription;
  pmColors$: Subscription;
  txtColor$: Subscription;
  textColor: string;
  _bgColors: string[] = [];
  primaryColors$: Subscription;
  _primaryColors: string[] = [];
  bgBasic: string[] = []
  bgPrimary: string[] = []
  bgAlt: string[] = []
  fillColors: string[];
  primaryColors: string[] = [];

  destroy$ = new Subject<void>();
  fillColor$: Subscription;
  fillColor: string; // = 'var(--background-basic-color-3)';

  color = "#FFF";
  bgColor: string;

  fillClass: string;

  heightOptions = [
    { value: 'dwarf-height', label: 'Dwarf' },
    { value: 'normal-height', label: 'Normal' },
    { value: 'giant-height', label: 'Giant' },
  ];
  heightOption;

  widthOptions = [
    { value: 'contained-width', label: 'Contained' },
    { value: 'full-width', label: 'Full Width' }
  ];
  widthOption;

  component: any = ColorPickerPopoverComponent;

  @ViewChild('popover', { read: ElementRef }) popover: ElementRef<HTMLElement>

  constructor(private communicator: IframeCommunicationService,
    private cssService: CssServicesService,
    private cellEditorStoreService: CellEditorStoreService,
    private previewEditStoreService: PreviewEditStoreService,
    private dialogService: NbDialogService) {
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      if (cell) {
        console.log(cell)
        this.selectedCell = cell;
        this.cellId = cell.cellId;
        this.fillColor = cell.fillColor;
        this.fillClass = cell.fillClass;
      }
    })
  }

  ngOnInit(): void {
    this.fillColor$ = this.cellEditorStoreService.fillColor$.subscribe((fillColor: string) => {
      if (fillColor == undefined || fillColor.startsWith("var")) {
        this.cssService.getBgColors().pipe(take(1)).subscribe((colorKV: any[]) => {
          this.fillColor = colorKV[2].val;
        })
      } else {
        this.fillColor = fillColor;
        console.log(this.fillColor);
        this.cellEditorStoreService.selectedCell$.subscribe(cell => {
          if (cell.fillClass == undefined || cell.fillClass == "default" || cell.fillClass == "class-2") {
            cell.bgColor = fillColor;
            console.log("cell-editor-store.service.ts - updating selected cell bgColor: " + cell);
            this.cellEditorStoreService.updateSelectedCell(cell)
          } else {
            console.log(cell.fillClass)
          }
        })
      }

    })
    this.bgColors$ = this.cssService.getBgColors().pipe(take(1)).subscribe((colorKV: any[]) => {
      // console.log(colorKV);
      colorKV.forEach((colorObj, i) => {
        if (i < 4) {
          this.bgBasic.push(colorObj.val)
        } else if (i > 3 && i < 8) {
          this.bgPrimary.push(colorObj.val)
        } else if (i > 7) {
          this.bgAlt.push(colorObj.val)
        }

      })
      // this.fillColors = this.bgBasic.concat(this.bgPrimary).concat(this.bgAlt);
    })
    this.pmColors$ = this.cssService.getPmColors().pipe(take(1))
      .subscribe((colorKV: any[]) => {
        // console.log(colorKV)
        colorKV.forEach((colorObj) => {
          this.primaryColors.push(colorObj.val)
        })
        this.fillColors = this.bgBasic.concat(this.primaryColors).concat(this.bgAlt);
      })
    this.primaryColors$ = this.communicator.receive("colorScheme").pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        console.log(data);
        this._primaryColors = [];
        for (const [k, v] of Object.entries(data.data.options)) {
          this._primaryColors.push(<string>v);
        }
        this.color = this._primaryColors[4];

      })
    this.pageBgColor$ = this.communicator.receive("pageBgColor").pipe(take(1))
      .subscribe((payload: any) => {
        console.log(payload);
        this.pageBgColor = payload.data;
      })
  }

  changeComplete(e) { }
  handleBgChange(e) {
    console.log(e)
    this.bgColor = e.color.hex;
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      cell.bgColor = this.bgColor;
      console.log("cell-editor-store.service.ts - updating selected cell bgColor: " + cell);
      this.cellEditorStoreService.updateSelectedCell(cell);
    })
    /* if(this.section.rendererType == "testimonials"){
    } */
  }

  handleFillChange(e) {
    console.log(e)
    if (e.color.rgb.a < 1) {
      this.fillColor = "rgb(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.color.rgb.a + ")";
    } else {
      this.fillColor = e.color.hex;
    }
    console.log(this.fillColor);
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      if (this.fillClass == undefined) {
        console.log("fillClass undefined ... doining bgColor")
        cell.bgColor = this.fillColor;
        console.log("cell-editor-store.service.ts - updating selected cell bgColor: " + cell);
        this.cellEditorStoreService.updateSelectedCell(cell);
      } else {
        cell.fillColor = this.fillColor;
        // cell.bgColor = this.fillColor;
        console.log("cell-editor-store.service.ts - updating selected cell bgColor: " + cell);
        this.cellEditorStoreService.updateSelectedCell(cell);
        // this.cellEditorStoreService.updateFillColor(this.fillColor);
      }

      // this.cellEditorStoreService.patchState({selectedCell:cell});
    })

  }

  imageDialog() {
    this.dialogService.open(SampleImageDirectoryComponent, {
      context: {
        title: 'Gallery',
      },
    });
  }

  onUseBg() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["section"]) {
      console.log(this.section);
      console.log(this.cellId);
    }
    if (changes["isPopup"]) {
      console.log(this.popover.nativeElement);
      console.log(this.width);
      this.popover.nativeElement.style.width = this.width;
    }
  }

  setFill(fillClass: string) {
    console.log("Setting Fillclass: " + fillClass + " cellId: " + this.cellId);
    // this.fillClass = fillClass;
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      if (cell.cellId == this.cellId) {
        cell.fillClass = fillClass;
        if (this.fillColor != undefined) {
          cell.fillColor = this.fillColor;
        }
        // this.cellEditorStoreService.patchState({selectedCell:cell});

        // this.previewEditStoreService.updateEditState(EditState.UPDATED)
      } else {
        cell.fillClass = fillClass;
        cell.fillColor = this.fillColor;
      }
      this.cellEditorStoreService.updateFillClass(fillClass);
    })

  }

  onUseFill() {
    if (this.section.rendererType == "banner") {
      this.cellEditorStoreService.updateLastActionState(LastActionEnum.IMAGE_SET);
    } else {
      this.cellEditorStoreService.updateLastActionState(LastActionEnum.BG_SET)
    }

  }

  setBgImage(e) {
    // this.imgSrc = "url("+e+")";
    console.log(e)
    // this.cellEditorStoreService.updateImgSrc(this.imgSrc);
    // console.log(e)
  }

  onWidthChange(e) {
    this.cellEditorStoreService.updateWdthClass(e);
  }

  onHeightChange(e: string) {
    console.log(e)
    this.cellEditorStoreService.updateHgthClass(e);

  }

  ngAfterViewInit(): void {
    if (this.isPopup) {
      this.popover.nativeElement.style.width = this.width;
      // cdk-overlay-pane
      const host = this.popover.nativeElement;
      const parentEl = this.getParent(host);
      parentEl.style
      const styles = getComputedStyle(parentEl);
      const left = styles.getPropertyValue("left");
      /* while (!parentEl.classList.contains("cdk-overlay-pane")) {
        host = parentEl;
        this.getParent(host);
      } */
      console.log(parentEl);
      console.log(left);
      console.log(parentEl.getAttribute("style"));
      setTimeout(() => {
        console.log(parentEl);
        console.log(left);
        console.log(parentEl.getAttribute("style"));
        parentEl.style.left = "0px";
        parentEl.style.setProperty("--popover-border-color", "#6a727f");
        parentEl.style.setProperty("--popover-background-color", "transparent");
      }, 1);
    }
  }

  getParent(el: HTMLElement) {
    return el.parentElement.parentElement.parentElement.parentElement;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
